export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  portfolio: "nav-portfolio",
  contact: "nav-contact",
  concept: "nav-concept",
  cta: "nav-cta",
  menuToggle: "nav-menu-toggle",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  brief: "contact-brief",
  submit: "contact-submit",
  whatsapp: "contact-whatsapp",
  emailCta: "contact-email-cta",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  newsletter: "footer-newsletter",
  newsletterSubmit: "footer-newsletter-submit",
};
